import { render, staticRenderFns } from "./passwordChangeModal.vue?vue&type=template&id=22c52b8c&"
import script from "./passwordChangeModal.vue?vue&type=script&lang=ts&"
export * from "./passwordChangeModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports